<template>
  <Modal
    title="Edit Lead"
    @hide-modal="$emit('hide-modal')"
    @submit="handleJobLeadUpdate"
  >
    <div class="d-flex gap-3">
      <ChoiceBoxV2
        v-model="formData.lead_type"
        name="Lead Type"
        class="flex-1"
        label="Lead Type"
        type="lead_types"
        placeholder="None"
      />
      <ChoiceBoxV2
        v-model="formData.lead_source"
        name="Lead Source"
        class="flex-1"
        label="Lead Source"
        type="lead_sources"
        placeholder="None"
      />
    </div>
  </Modal>
</template>

<script>
import { mapActions } from "vuex";

import ChoiceBoxV2 from "@/components/ChoiceBoxV2.vue";
import Modal from "@/components/Modal.vue";
import TextField from "@/components/TextField.vue";

export default {
  components: {
    ChoiceBoxV2,
    TextField,
    Modal
  },
  props: {
    job: {
      type: Object,
      default: () => ({})
    },
    tableMode: {
      type: Boolean,
      default: false
    }
  },
  emits: ["hide-modal", "success-update"],
  data() {
    return {
      formData: {}
    };
  },
  mounted() {
    this.formData = {
      lead_type: this.job.lead_type,
      lead_source: this.job.lead_source
    };
  },
  methods: {
    ...mapActions(["updateJobLeadType"]),
    handleJobLeadUpdate() {
      this.updateJobLeadType({
        jobId: this.job.id,
        lead: {
          lead_type: this.formData.lead_type || null,
          lead_source: this.formData.lead_source || null
        },
        tableMode: this.tableMode
      }).then(() => {
        window.notify.success("Job lead updated successfully!");
        this.$emit("hide-modal");
        this.$emit("success-update");
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
